// @ts-ignore
import { Router } from '../configs/routes';

export const getSubHeading = (detailsSlug: string) => {
  let heading;
  if (detailsSlug === 'first') {
    heading = 'Step 1. Enter Personal Details';
  } else if (detailsSlug === 'second') {
    heading = 'Step 2. Enter banking Details';
  } else if (detailsSlug === 'third') {
    heading = 'Step 3. Enter Nominee Details';
  } else if (detailsSlug === 'payment') {
    // heading = 'Step 4. Make Payment';
    heading = 'Make Payment';
  }
  return heading;
};

export const handleBackNavigation = (detailsSlug: string) => {
  let slug;
  if (detailsSlug) {
    if (detailsSlug === 'second') {
      // this.pushStateAndNavigate('first');
      slug = 'first';
    } else if (detailsSlug === 'third') {
      // this.pushStateAndNavigate('second');
      slug = 'second';
    } else if (detailsSlug === 'payment') {
      // this.pushStateAndNavigate('second');
      slug = 'third';
    }
  }
  return slug;
};

export const pushModalStateAndNavigate = (slug: string) => {
  const { pathname, search } = window.location;
  const newSearch = search.replace(
    /(=?(first)|=?(second)|=?(third)|=?(payment))/g,
    `=${slug}`
  );
  return `${pathname}${newSearch}`;
};

export const disableBackButton = (
  detailsSlug: string,
  alreadyInvested: boolean = false
) => {
  return (
    !detailsSlug ||
    detailsSlug === 'first' ||
    (detailsSlug === 'payment' && alreadyInvested)
  );
};

export const handleBackAction = (detailsSlug: string) => {
  const slug = handleBackNavigation(detailsSlug);
  const url = pushModalStateAndNavigate(slug);
  Router.pushRoute(url, url, { shallow: true });
};



// WEBPACK FOOTER //
// ./utils/paymentModalUtils.ts